<template>
  <div class="terms-page">
    <!-- ===== 顶部标题区 ===== -->
    <!-- <section class="terms-header">
      <div class="terms-header-bg">
        <div class="terms-orb terms-orb-1"></div>
        <div class="terms-orb terms-orb-2"></div>
      </div>
      <div class="terms-header-content">
        <span class="section-badge">📜 法律文件</span>
        <h1 class="terms-title">Terms of <span class="highlight">Use</span></h1>
        <p class="terms-subtitle">Radiant Infrastructure Ltd</p>
        <p class="terms-desc">
          本协议最后更新于 2026 年 8 月 6 日<br />
          请仔细阅读以下条款和条件
        </p>
      </div>
    </section> -->

    <!-- ===== 主体：左侧锚点 + 右侧内容 ===== -->
    <section class="terms-body">
      <div class="terms-container">
        <!-- 左侧锚点导航 -->
        <aside class="terms-sidebar">
          <div class="sidebar-sticky">
            <div class="sidebar-title">📑 目录</div>
            <nav class="sidebar-nav">
              <a
                v-for="item in toc"
                :key="item.id"
                :href="`#${item.id}`"
                class="sidebar-link"
                :class="{ active: activeSection === item.id }"
                @click.prevent="scrollToSection(item.id)"
              >
                <span class="link-dot"></span>
                {{ item.label }}
              </a>
            </nav>
          </div>
        </aside>

        <!-- 右侧内容 -->
        <main class="terms-content">
          <!-- 1. 协议引言 -->
          <section id="tab1" class="terms-section">
            <h2 class="section-title-text">
              执掌数字黄金：成为智能时代的“超级新算力领主”
            </h2>
            <div class="section-content">
              <p>
                当全球大模型跨入万亿参数决战、具身智能全面爆发的今天，算力已经彻底取代石油，成为支配世界财富的终极硬通货。
                科技巨头们不惜代价疯狂扫货GPU，动辄数亿的智算中心造价将普通投资者拒之门外。Aetrivol顺应时代应运而生。我们通过创新的算力值锚定机制与算力服务器租赁模型，打破资产垄断，让您用最简单、最灵活的方式，直享这场全人类历史上最大的财富复利盛宴。
              </p>
              <!-- <div class="notice-box">
                <span class="notice-icon">⚠️</span>
                <div>
                  <strong>重要提示：</strong>
                  如果您没有这样的授权，或者您或您的组织不同意本协议的条款，您不应接受本协议。
                  Company may make access to the Service(s) and certain features
                  subject to certain requirements or conditions including but
                  not limited to requesting customer information, and meeting
                  specific eligibility requirements.
                </div>
              </div> -->
            </div>
          </section>

          <!-- 2. Definitions -->
          <section id="tab2" class="terms-section">
            <h2 class="section-title-text">核心产品矩阵：双轮驱动的财富引擎</h2>
            <div class="section-content">
              <div class="def-grid">
                <div>
                  <h3>
                    创新产品一：【算力值（Compute Value /
                    CV）】——全球算力资产的“通证化红利”
                  </h3>
                </div>
                <div class="def-item-">
                  <p>
                    ·
                    打破门槛，微型资产化：我们把全球实体智算中心、高端GPU服务器（英伟达Blackwell、华为昇腾等）的整体算力进行标准化拆分。1点【算力值】，就代表您拥有全球智算网络中特定份额的算力所有权。
                  </p>
                  <p>
                    ·
                    像买基金一样买GPU：最低仅需小额资金认购【算力值】，即可打破“一卡难求”的壁垒。您持有的算力值在平台中24小时不间断运行，每日躺迎该算力在全球AI大模型、智能体（Agent）调用中所产生的数字化现金流分红。
                  </p>
                  <p>
                    ·
                    高流动性，随时变现：算力值具备极强的资产流动性。随着全球算力需求的暴增，算力值本身具备极高的溢价空间，您可随时在平台内进行交易变现。
                  </p>
                </div>

                <div>
                  <h3>
                    核心业务二：【算力服务器租赁（Server Leasing）】——
                    稳健长协的“数字包租公”模型
                  </h3>
                </div>
                <div class="def-item-">
                  <p>
                    ·
                    实体资产认购，专属服务器所有权：投资者可直接认购平台旗下的整台或标准机柜的算力服务器。每一台服务器均在链上真实映射、拥有唯一实体机身SN码。
                  </p>
                  <p>
                    ·
                    长协托管租赁，坐收稳定高租金：认购后，服务器直接托管于平台在全球绿色算力枢纽（如中国西部东数西算节点、北欧、中东等）的顶级智算中心内。平台替您将服务器精准租赁给急需算力的大模型研发商、高校科研所或垂直领域AI企业，为您锁定3至5年的长协稳定高回报租金。
                  </p>
                  <p>
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </section>

          <!-- 3. LICENCE AND SUPPORT SERVICES -->
          <section id="tab3" class="terms-section">
            <h2 class="section-title-text">
              为什么Aetrivol能够化风险为绝对确定性？
            </h2>
            <div class="section-content">
              <p>
                · 100%
                物理资产链上锚定：我们拒绝空中楼阁。无论是您持有的算力值，还是您租赁的服务器，均在链上实时映射到正在并网、高频轰鸣的实体加速卡硬件上，资产看得见、摸得着、可核验。
              </p>
              <p>
                ·
                顶尖能效与“抗地缘”双保险：我们包装的标的数据中心100%配备“微型核能（SMR）/光伏直供电”或处于绝对安全的非冲突法律管辖区，彻底规避全球局部电网海啸和地缘政治波动的风险。
              </p>
              <p>
                ·
                巨头信用背书与长协保障：平台优先挑选被微软、OpenAI、DeepSeek等大模型巨头提前锁定租赁的成熟站点，用科技巨头的信用为您做收益背书。
              </p>
              <p>
                <br />
              </p>
            </div>
          </section>

          <!-- 4. CUSTOMER RESPONSIBILITIES -->
          <section id="tab4" class="terms-section">
            <h2 class="section-title-text">
              过去他们投资土地、投资石油；今天，我们投资算力。
            </h2>
            <div class="section-content">
              <p>
                当全人类的智慧和业务都在向数字世界迁移，算力就是这个新世界唯一的建筑材料。加入
                Aetrivol，购买您的算力值，开启您的算力服务器租赁之旅。把您的资本转化为重塑世界的算力原子，共享这场智能激增的财富狂飙！
              </p>
            </div>
          </section>

          <!-- 底部页脚 -->
          <!-- <div class="terms-footer">
            <p>© 2026 Radiant Infrastructure Ltd. All rights reserved.</p>
            <p class="footer-update">Last Updated: August 6, 2026</p>
          </div> -->
        </main>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
  data() {
    return {
      activeSection: "introduction",
      toc: [
        { id: "tab1", label: "执掌数字黄金" },
        { id: "tab2", label: "核心产品矩阵" },
        { id: "tab3", label: "Aetrivol安全可靠" },
        { id: "tab4", label: "投资价值" },
      ],
    };
  },
  methods: {
    scrollToSection(id) {
      this.activeSection = id;
      const element = document.getElementById(id);
      if (element) {
        const offset = 80;
        const top =
          element.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
    },
  },
  mounted() {
    // 滚动监听高亮
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.activeSection = entry.target.id;
          }
        });
      },
      { threshold: 0.3, rootMargin: "-80px 0px 0px 0px" },
    );

    this.toc.forEach((item) => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });
  },
};
</script>

<style scoped>
/* ============================================================
   通用
   ============================================================ */
.terms-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background: #0a0e1a;
  color: #fff;
  overflow-x: clip;
}

.section-badge {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 20px;
  background: rgba(0, 180, 255, 0.08);
  border: 1px solid rgba(0, 180, 255, 0.1);
  font-size: 13px;
  color: #00b4ff;
  margin-bottom: 12px;
}

.highlight {
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.highlight-text {
  color: #00b4ff;
}

/* ============================================================
   顶部标题区
   ============================================================ */
.terms-header {
  padding: 80px 20px 60px;
  position: relative;
  overflow: hidden;
  text-align: center;
  background: linear-gradient(135deg, #080c18, #0f1a2e);
}

.terms-header-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.terms-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.12;
}

.terms-orb-1 {
  width: 500px;
  height: 500px;
  background: #00b4ff;
  top: -250px;
  left: -100px;
}

.terms-orb-2 {
  width: 400px;
  height: 400px;
  background: #7c3aed;
  bottom: -200px;
  right: -80px;
}

.terms-header-content {
  position: relative;
  z-index: 1;
}

.terms-title {
  font-size: 56px;
  font-weight: 900;
  margin: 8px 0;
}

.terms-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 8px 0;
}

.terms-desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.35);
  line-height: 1.8;
  margin: 0;
}

/* ============================================================
   主体：左侧锚点 + 右侧内容
   ============================================================ */
.terms-body {
  padding: 40px 20px 80px;
  background: #0a0e1a;
}

.terms-container {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  gap: 48px;
  align-items: flex-start;
}

/* ===== 左侧侧边栏 ===== */
.terms-sidebar {
  flex: 0 0 260px;
  position: sticky;
  top: 75px;
  align-self: flex-start;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.terms-sidebar::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}

.sidebar-sticky {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px 16px;
}

.sidebar-title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  margin-bottom: 16px;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: all 0.25s ease;
  cursor: pointer;
}

.sidebar-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.04);
}

.sidebar-link.active {
  color: #00b4ff;
  background: rgba(0, 180, 255, 0.06);
}

.sidebar-link.active .link-dot {
  background: #00b4ff;
  box-shadow: 0 0 12px rgba(0, 180, 255, 0.4);
}

.link-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  flex-shrink: 0;
  transition: all 0.25s ease;
}

.sidebar-link:hover .link-dot {
  background: rgba(255, 255, 255, 0.3);
}

/* ===== 右侧内容 ===== */
.terms-content {
  flex: 1;
  min-width: 0;
}

.terms-section {
  margin-bottom: 48px;
  scroll-margin-top: 80px;
}

.section-title-text {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(0, 180, 255, 0.1);
}

.section-content {
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.8;
  font-size: 15px;
}

.section-content p {
  margin: 0 0 10px 0;
}

.section-content h3 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 28px 0 12px 0;
}

.section-content h3:first-of-type {
  margin-top: 0;
}

/* ===== 通用列表 ===== */
.terms-list {
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
}

.terms-list li {
  position: relative;
  padding: 8px 0 8px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.terms-list li::before {
  content: "▸";
  position: absolute;
  left: 0;
  color: #00b4ff;
}

.terms-list li:last-child {
  border-bottom: none;
}

.terms-list li strong {
  color: #fff;
}

/* ===== 通知框 ===== */
.notice-box {
  display: flex;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 12px;
  background: rgba(0, 180, 255, 0.04);
  border: 1px solid rgba(0, 180, 255, 0.08);
  margin: 16px 0;
}

.notice-box.notice-warning {
  background: rgba(255, 215, 0, 0.04);
  border-color: rgba(255, 215, 0, 0.08);
}

.notice-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.notice-box strong {
  color: #fff;
}

/* ===== Definitions 网格 ===== */
.def-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.def-item {
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  transition: all 0.25s ease;
}

.def-item:hover {
  border-color: rgba(0, 180, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.def-term {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  color: #00b4ff;
  font-family: "SF Mono", "Courier New", monospace;
  margin-bottom: 6px;
}

.def-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  line-height: 1.7;
}

.def-link {
  color: #00b4ff;
  text-decoration: none;
}

.def-link:hover {
  text-decoration: underline;
}

/* ===== IP 网格 ===== */
.ip-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 12px;
}

.ip-card {
  display: flex;
  gap: 14px;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  transition: all 0.25s ease;
}

.ip-card:hover {
  border-color: rgba(0, 180, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.ip-icon {
  font-size: 28px;
  flex-shrink: 0;
}

.ip-card h4 {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.ip-card p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  line-height: 1.5;
}

/* ===== Payment 高亮 ===== */
.payment-highlight {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-top: 12px;
}

.payment-item {
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  text-align: center;
}

.payment-label {
  display: block;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.payment-value {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}

/* ===== Liability 卡片 ===== */
.liability-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.liability-item {
  display: flex;
  gap: 14px;
  padding: 18px 20px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
}

.liability-icon {
  font-size: 28px;
  flex-shrink: 0;
}

.liability-item h4 {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.liability-item p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  line-height: 1.5;
}

/* ===== General 网格 ===== */
.general-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.general-item {
  display: flex;
  gap: 14px;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  transition: all 0.25s ease;
}

.general-item:hover {
  border-color: rgba(0, 180, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.general-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.general-item h4 {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.general-item p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  line-height: 1.5;
}

/* ===== 底部页脚 ===== */
.terms-footer {
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  text-align: center;
}

.terms-footer p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.2);
  margin: 4px 0;
}

.terms-footer .footer-update {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.12);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 1024px) {
  .terms-container {
    flex-direction: column;
  }

  .terms-sidebar {
    flex: unset;
    position: static;
    width: 100%;
  }

  .sidebar-sticky {
    padding: 16px 12px;
  }

  .sidebar-nav {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 4px;
  }

  .sidebar-link {
    padding: 6px 14px;
    font-size: 13px;
  }

  .sidebar-link .link-dot {
    display: none;
  }

  .sidebar-title {
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .ip-grid,
  .payment-highlight,
  .liability-card,
  .general-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .terms-title {
    font-size: 36px;
  }

  .terms-header {
    padding: 50px 16px 40px;
  }

  .section-title-text {
    font-size: 22px;
  }

  .terms-body {
    padding: 20px 16px 60px;
  }

  .terms-section {
    margin-bottom: 32px;
  }

  .def-item {
    padding: 12px 16px;
  }

  .payment-highlight {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .terms-title {
    font-size: 28px;
  }

  .section-title-text {
    font-size: 20px;
  }

  .sidebar-link {
    font-size: 12px;
    padding: 4px 10px;
  }

  .ip-card,
  .liability-item,
  .general-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .notice-box {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
